import React, { memo } from 'react';
import dayjs from 'dayjs';

import style from './style.module.css';

const formatDate = date => (date ? dayjs(date).format('MMM D, YYYY') : '-');

const ProjectHeaderComponent = ({ project }) => {
  const industries = [
    ...(project?.get('businessModels')?.toJS() ?? []),
    ...(project?.get('industryCategoryTags')?.toJS() ?? []),
  ];

  const directorsText =
    project
      ?.get('directors')
      .map(director => `${director.get('firstName')} ${director.get('lastName')}`)
      .join(' · ') || '';
  const dealmakersText =
    project
      ?.get('dealmakers')
      .map(dealmaker => `${dealmaker.get('firstName')} ${dealmaker.get('lastName')}`)
      .join(' · ') || '';
  const researchText =
    project
      ?.get('research')
      .map(research => `${research.get('firstName')} ${research.get('lastName')}`)
      .join(' · ') || '';

  return (
    <div className={style.host}>
      <div className={style.status}>Status: {project?.get('active') ? 'Active' : 'Closed'}</div>
      <h2 className={style.title}>{project?.get('buyerLegalName')}</h2>
      <div className="row">
        <div className="col-md-6">
          <div className={style.type}>
            {project?.get('buyerType')} Buyer <span className="pl3 pr3">·</span> {project?.get('category')}
          </div>
          <div className="mt8">
            <b>Industries</b> <span className={style.muted}>{industries.map(tag => tag.category).join(', ')}</span>
          </div>
          <div className="mt16">
            <p className="mb0">
              <span className={style.muted}>Kickoff Date</span> {formatDate(project?.get('createdAt'))}
            </p>
            <p>
              <span className={style.muted}>Last List</span> {formatDate(project?.get('lastListDate'))}
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-4">
              <b className={style.status}>Director</b>
              <p>{directorsText}</p>
            </div>
            <div className="col-md-4">
              <b className={style.status}>Dealmakers</b>
              <p>{dealmakersText}</p>
            </div>
            <div className="col-md-4">
              <b className={style.status}>Research</b>
              <p>{researchText}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ProjectHeader = memo(ProjectHeaderComponent);
